// extracted by mini-css-extract-plugin
export default {"bg":"staffs_bg__HcQiA","bgLayer":"staffs_bgLayer__9gpNz","slide":"staffs_slide__SGege"};